import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { List } from 'devextreme-react/list'

// todo: try storing items and nFieldsTouched in memo??
export const ValidationSummary = ({ errors, labelsMap, touched, thunkErrors=[] }: any) => {
    const { t } = useTranslation()


    const items = useMemo<any[]>(() => {
        const touchedFields = Object.keys(errors).filter(k => touched[k])
        let items = touchedFields.map((k: string) => {
            if (labelsMap[k]) {
                return `${t(labelsMap[k])}: ${t(errors[k].key, errors[k].options)}`
            } else {
                return `${k}: ${t(errors[k].key, errors[k].options)}`
            }
        })

        if ((errors as any).globalErrors) {
            const { error } = (errors as any).globalErrors
            error && (items = items.concat(error.map((e: any) => t(e.key, e.options))))
        }

        thunkErrors.forEach((thunkError: any) => {
            if (typeof(thunkError) === 'object') {
                items = items.concat(thunkError.error.map((e: any) => t(e.key, e.options)))
            }
        })

        return items
    }, [errors, touched, labelsMap, thunkErrors, t])

    if ((!errors || !touched) && !thunkErrors.filter((x: any) => typeof(x) === 'object').length) { return null; }


    // const nFieldsTouched = Object.values(touched).filter(v => v).length

    return items.length
        ? (
            <>
                <h5>Validation errors</h5>
                <List items={items} />
            </>
        )
        : null
}
